{
  "user-profile": {
    "buttons": {
      "confirm-email": "Confirm email",
      "confirm-phone-nr": "Confirm phone number",
      "update": "Update",
      "update-password": "Update password",
      "update-phone-nr": "Update phone number"
    },
    "text": {
      "communication": "Communication",
      "communication-hint": "Most salons use email for communication (e.g. for appointment confirmations), but some also offer the option of using SMS. Would you prefer to receive SMS in these cases?",
      "confirm-email": "Please confirm your email",
      "confirm-phone-nr": "Please confirm your phone number",
      "contact-data": "Contact data",
      "in-second": "in {{seconds}} s",
      "password": "Password",
      "personal-data": "Personal data",
      "pin-code": "PIN code",
      "pin-code-hint": "Please set all {{ numberOfPinDigit }} PIN digits to update. This PIN is used only for logging into Beauty Checkin and Beauty Checkout apps.",
      "update-password-by-email": "The PIN code will be sent to you via email. You will need this PIN code to confirm your new password.",
      "update-password-by-sms": "The PIN code will be sent to you via SMS. You will need this PIN code to confirm your new password.",
      "update-success": "Updated successfully!",
      "via-email": "No",
      "via-sms": "Yes"
    }
  }
}
